module.exports = __webpack_public_path__ + "media/images/twitter-bc35811e37dd6225c4687822b5424a17.svg";